// Properties always in this case: onboarding_step
export enum OnboardingStep {
  PICK_ONBOARDING_FLOW = 'pick_onboarding_flow',
  SIGN_UP_FORM = 'sign_up_form',
  CUSTOMIZE_ORGANIZATION = 'customize_organization',
}
